<template>
  <section class="section company-hire pt-5 pb-5">
    <div class="container position-relative">
      <div class="mb-5">
        <div class="conatiner-logo-general">
          <router-link to="/"><img src="@/assets/talento_agv/img/LOGO BLANCO.png" alt="" srcset=""></router-link>
        </div>

        <h3 class="header-title title-cultura text-center agv-text">
          Programa Young Talent
        </h3>
        <!-- <hr class="separador-title"> -->
        <h4 class="link-cultura" style="font-size:20px"><router-link to="/" class="item-link">Inicio</router-link> /
          Young Talent</h4>
      </div>

      <div class="video-banner-young mb-4">
        <iframe v-if="section_one.video" class="iframe-banner"
          :src="`${section_one.video}&autoplay=1&muted=1&loop=1&background=1`" frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture" allowfullscreen muted>
        </iframe>
        <div class="sobrefondo" style="background-color: rgba(0, 0, 0, 0.1) !important"></div>

        <div class="container-block-video-young">
          <div class="row">
            <div class="col-12 col-md-12">
              <!-- <h3 class="title-card-video">
                <img class="imag-arrow" src="@/assets/talento_agv/img/arrow-white.png" alt="">
                Asi vivimos nuestras <span class="bg-sky-blue">experiencias</span> en agrovision
              </h3> -->
            </div>
            <div class="col-12 col-md-12 text-center">
              <div class="container-play-young">
                <a data-bs-toggle="modal" href="#videoYoung">
                  <div class="container-icon-video-young">
                    <i class='bx bx-play'></i>
                  </div>
                  <div>
                    <h4>Ver el video</h4>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="">
        <!-- <p class="text-center text-white">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quas quidem numquam veniam rem.
          Facere deleniti illum, esse ullam in ducimus, enim ipsa magni quia, assumenda eveniet mollitia distinctio
          laborum!</p> -->
        <h3 class="title-card-video">
          <img class="imag-arrow" src="@/assets/talento_agv/img/arrow-white.png" alt="">
          {{ section_one.title }}
        </h3>
      </div>
    </div>
  </section>

  <!-- nuestros Young Talent -->
  <section class="section platform-location">
    <div class="container ">
      <div class="row">
        <div class="col-md-12 col-sm-12 col-12 mx-auto">
          <div class="section-header section-header-four section-locate aos aos-init aos-animate" style="opacity: 100;" data-aos="fade-up">
            <div class="text-center">
              <h2 class="header-title header-page-event">
                Conoce a nuestros <span class="bg-green">Young Talent</span>
              </h2>
              <!-- <hr class="separador-title"> -->
            </div>
          </div>
        </div>
      </div>
      <div class="carousel-cultura">
        <div class="grid-container">
          <div v-for="items in elementsCarousel" class="grid-item fondo">
            <!-- <img :src="require(`@/${items.img}`)" alt="" srcset=""> -->
            <a @click="eventDialog(items)" class="blog-container container-hover-video mx-2">
              <div class="blog-image-poster">
                <img :src="items.img" alt="">
                <div class="container-play-talent">
                  <div class="container-icon-video-young">
                    <i class='bx bx-play'></i>
                  </div>
                </div>
                <div class="blog-article-content">
                  <h6 class="name-employee">{{ items.name }}</h6>
                </div>
              </div>
            </a>
          </div>

        </div>
      </div>
    </div>
  </section>


  <div class="modal fade" id="videoYoung" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content modal-transparent">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalToggleLabel"></h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body" style="width: 100%;">
          <iframe :src="section_one.video" frameborder="0" allow="autoplay; picture-in-picture; clipboard-write;"
            style="width:100%;height:80vh;" allowfullscreen>
          </iframe>
        </div>

      </div>
    </div>
  </div>

  <!-- Crear Cuenta-->
  <section class="section job-register">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class="register-job-blk">
            <div class="job-content-blk aos" style="opacity: 100;" data-aos="fade-up" data-aos-duration="500">
              <h2>Sé el primero en recibir nuestras ofertas laborales</h2>
              <p>Crea una cuenta y encuentra el trabajo que buscas.</p>

              <router-link to="/crear_cuenta" class="btn all-btn">Crear Cuenta</router-link>
              <router-link to="/login" class="btn all-btn">Ingresar</router-link>
            </div>
            <div class="see-all mt-0 aos opportunity" style="opacity: 100;" data-aos="zoom-in" data-aos-duration="700">
              <img src="@/assets/img/opportunity.png" alt="img">
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="text-center pa-4">
    <v-dialog v-model="dialog" width="auto">
      <v-card max-width="900" class="modal-transparent">
        <template v-slot:text style="width: 100%; height: 600px;">
          <iframe :src="urlVideo" frameborder="0" allow="autoplay; picture-in-picture; clipboard-write;"
            style="width:800px;height:600px;" allowfullscreen></iframe>

        </template>
      </v-card>
    </v-dialog>
  </div>

  <!-- Pie de Página -->
  <footeragv></footeragv>
</template>
<script>
import axiosIns from '@/plugins/axios.js';
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
export default {
  data() {
    return {
      dialog: false,
      urlVideo: '',
      elementsCarousel: [
        // {
        //   "id": "1",
        //   "img": "assets/talento_agv/img/young_talent/young_talent1.jpg",
        //   "puesto": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet aut quibusdam fugit harum hic? Cumque nostrum ratione pariatur dolorem delectus nam excepturi blanditiis ipsa. Magni assumenda aspernatur molestiae enim atque.",
        //   "name": "Nelson Guardado",
        //   "video_url": "https://player.vimeo.com/video/695214081"
        // },
        // {
        //   "id": "2",
        //   "img": "assets/talento_agv/img/young_talent/young_talent2.jpg",
        //   "puesto": "SEO",
        //   "name": "Diana Ocampo",
        //   "video_url": "https://player.vimeo.com/video/743745811"
        // },
        // {
        //   "id": "3",
        //   "img": "assets/talento_agv/img/young_talent/young_talent3.jpg",
        //   "puesto": "Illustration",
        //   "name": "Esteban Córdova",
        //   "video_url": "https://player.vimeo.com/video/695214593"
        // },
        // {
        //   "id": "4",
        //   "img": "assets/talento_agv/img/young_talent/young_talent4.jpg",
        //   "puesto": "Translation",
        //   "name": "Nombre Colaborador",
        //   "video_url": "https://player.vimeo.com/video/694015733"
        // },
        // {
        //   "id": "5",
        //   "img": "assets/talento_agv/img/young_talent/young_talent5.jpg",
        //   "puesto": "Jefa de Campo - Arandano",
        //   "name": "Juana Suar",
        //   "video_url": "https://player.vimeo.com/video/714540463"
        // },
      ],
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 700px and up
        767: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        // 991px and up
        1024: {
          itemsToShow: 3.5,
          snapAlign: "center",
        },
        //   // 1024 and up
        //   1024: {
        //     itemsToShow: 4.9,
        //     snapAlign: "start",
        //   },
      },

      section_one: [],
      dataTableTestimonials: [],

      language: null,

    };
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  mounted() {
    this.getPageData()
    this.getTestimonials()
  },
  methods: {
    eventDialog(items) {
      this.dialog = true
      this.urlVideo = items.video_url
    },
    getPageData() {
      const yo = this
      const config = {
        method: 'get',
        url: '/talentoagv/getMainPageData/',
      }

      if (this.$store.getters.currentPublicLanguage == 'es') {
        yo.language = '1'
      }
      else if (this.$store.getters.currentPublicLanguage == 'en') {
        yo.language = '2'
      }

      axiosIns(config)
        .then(function (response) {
          // console.log(response.data['result'])
          if (response.data['is_error'] === false) {
            let resultado = response.data['result']
            for (let r of resultado) {
              if (r['idlanguage'] == yo.language) {
                if (r['section'] == 'uno' && r['idpage'] == '5') {
                  yo.section_one = r
                }
              }
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
          yo.$toastr.error("Error consulte con su administrador", 'Error')
        })
        .finally(function () {

        })
    },

    getTestimonials() {
      const yo = this
      yo.dataTableTestimonials = []
      yo.elementsCarousel = []
      const data = JSON.stringify({
        pagina: '5',
        seccion: '10',
      })
      const config = {
        method: 'post',
        url: '/talentoagv/readTestimonials/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data,
      }

      axiosIns(config)
        .then(function (response) {
          // console.log("informacion de testimonios",response.data['result'])
          if (response.data['is_error'] === false) {
            let resultado = response.data['result']
            for (let r of resultado) {
              if (r['key_idioma_id'] == yo.language && r['s3_url'] != null) {
                yo.elementsCarousel.push({
                  'name': r['name'],
                  'img': r['s3_url'],
                  'video_url': r['video'],
                  'id': r['id']
                })
              }
            }
            // yo.dataTableTestimonials = response.data['result']
          }
        })
        .catch(function (error) {
          // console.log(error);
          yo.$toastr.error("Consulte con su Administrador", 'Error')
        })
        .finally(function () {

        })
    },

  },
};
</script>
<style>
.banner {
  width: 100%;
  height: 280px;
  background-image: url('../../../../assets/img/fondo_principal_inicio.png');
  background-size: contain;
  background-position: center bottom;
}

.banner::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 280px;
  background-color: rgba(0, 0, 0, 0.4);
  /* Color negro semi-transparente */
}

.descrip_atributo:hover {
  /* position: absolute;
    width: 100%;
    height: 100%; */
  background: none;
  opacity: 0;
  /* Inicialmente oculto */
  display: flex;
  /* justify-content: center;
    align-items: center; */
}

@media(max-width:1220px) {
  .testimonios_young_talent .vector-rayas {
    height: 50% !important;
  }
}

@media(max-width:800px) {
  .testimonios_young_talent .vector-rayas {
    height: 30% !important;
  }
}


@media(max-width:480px) {
  .titulo_banner {
    width: 400px !important;
    margin-left: -200px !important;
  }
}

@media(max-width:400px) {
  .titulo_banner {
    width: 360px !important;
    margin-left: -180px !important;
  }

  .testimonios_young_talent .vector-rayas {
    height: 20% !important;
  }
}
</style>